/** Aprendizado da associação da NF-e de entrada (Fase B3): código, unidade e fator que o fornecedor usa para o produto. */
export class UpsertCodigoFornecedorRequest {
  public idProduto: number = 0;
  public idFornecedor: number = 0;
  public codigo: string = '';
  public unidadeMedida: string | null = null;
  public fatorConversao: number | null = null;
}
